import React, { useEffect, useState } from 'react';
import './chatTabs.css'
import LiveLike  from "@livelike/engagementsdk";
import {useDispatch, useSelector} from "react-redux";
import blueRobot from '../../assets/images/bluerobot.png'
import redRobot from '../../assets/images/redrobot.png'
import blackRobot from '../../assets/images/yellowrobot.png'
import yellowRobot from '../../assets/images/blackrobot.png'
import './demoapp.css'
import './custom-widget.css'
import GroupChat from "./GroupChat/GroupChat";
// import Timeline from "./Timeline/Timeline";
import PublicChat from "./PublicChat/PublicChat";

import {setChatUserProfile} from "../../store/reducers/chatReducer";
import useIsMobilePlatform from "../../hooks/useIsMobilePlatform";
import Timeline from "./Timeline/Timeline";

const ChatTabs = ({closeChatWindow}) => {

    const { userName, token } = useSelector(state => state.participant);
    const dispatch = useDispatch();
    const [userProfile, setUserProfile] = useState(null);
    const [selectedRoom, setSelectedRoom] = useState(1);
    const [changeProfile, toggleChangeProfile ] = useState(false)
    const [nikname, setNikname ] = useState(userName)
    const [avatar, selectAvatar] = useState(blueRobot)
    const isMobile = useIsMobilePlatform()
    const navActive = 'nav-link active';
    const navInactive = 'nav-link';
    const contentActive = 'tab-pane fade show active';
    const contentInactive = 'tab-pane fade'

    useEffect(() => {
            LiveLike.init({
                clientId: process.env.REACT_APP_CHAT_CLIENT_ID,
            }).then((newUser) => {
                setUserProfile(newUser)
                setNikname(newUser.nickname)
                // selectAvatar(newUser.custom_data)
                dispatch(setChatUserProfile(newUser))
                LiveLike.updateUserProfile({ accessToken: newUser.access_token, options: {
                        nickname: userName,
                    }}).then((result) => {
                } )
            } )

        LiveLike.applyLocalization({"en": {
                "chat.inputPlaceholder": "Schreib etwas...",
                "chat.messageMenu.blockUser": "Diesen Benutzer blockieren",
                "chat.messageMenu.reportMessage": "Nachricht melden",
                "chat.messageMenu.cancel": "Abbrechen",
                "chat.messageMenu.ariaLabel": "Nachrichtenoptionen",
                "chat.blockConfirmation.message": "Sie werden keine Nachrichten mehr von diesem Benutzer sehen.",
                "chat.reportConfirmation.message": "Die Nachricht wurde den Moderatoren gemeldet. Vielen Dank.",
                "chat.mutedMessage": "Nachricht kann nicht gesendet werden.",
                "chat.errorMessage": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                "chat.messageDeleted": "Diese Nachricht wurde entfernt.",

                "chat.sendButton.ariaLabel": "Nachricht senden",
                "chat.scrollDownButton.ariaLabel": "Nach unten scrollen",
                "chat.stickerPicker.title": "AUFKLEBER",
                "chat.stickerPicker.openButton.ariaLabel": "Sticker öffnen",
                "chat.stickerPicker.closeButton.ariaLabel": "Aufkleber schließen",
                "chat.giphyPicker.title": "GIPHY",

                "chat.giphyPicker.placeholder": "GIFs über GIPHY suchen",
                "chat.giphyPicker.openButton.ariaLabel": "Öffne GIPHY",
                "chat.giphyPicker.closeButton.ariaLabel": "GIPHY schließen\"",
                "chat.reactions.openButton.ariaLabel": "Nachrichtenreaktionen",
                "widget.quiz.voteButton.label": "Abstimmen",
                "widget.quiz.votedText": "Gevotet!",
                "widget.slider.voteButton.label": "Abstimmen",
                "widget.slider.votedText": "Gewählt!"
        }})

    }, [])

    const updateProfile = () => {
        const newNick = document.getElementById('profileNickname').value;

        console.log('avatar ',avatar, blueRobot)

        LiveLike.updateUserProfile({ accessToken: userProfile.access_token, options: {
            nickname: newNick,
            custom_data:  avatar,
            }}).then((result) => {
            toggleChangeProfile(false)
        } )
    }


    return (<div id="right-panel" className="column two">
        {isMobile && <div className="close-chat-button" onClick={() => closeChatWindow()}></div> }
        <header className="main-header">
            <div className="logo">
            </div>
            <div className="actions">
                <a className="profile profile-wrap">
                    <div data-toggle="modal" data-target="#my-profile" onClick={() => {
                        toggleChangeProfile(true)
                    }}>
                        <img
                            src={avatar}
                            id="my-profile-image"
                        />
                    </div>
                    <div className="profile-stats"></div>
                </a>
            </div>
        </header>

        <div className="widget-container">
            <livelike-widgets id="pop-up"></livelike-widgets>
        </div>

        <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
            <li className="nav-item">
                <a
                    className={selectedRoom === 1 ? navActive: navInactive}
                    onClick={() => {setSelectedRoom(1)}}
                    id="timeline-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="timeline"
                >INFO</a
                >
            </li>
            <li className="nav-item">
                <a
                    className={selectedRoom === 2 ? navActive: navInactive}
                    onClick={() => {setSelectedRoom(2)}}
                    id="public-chat-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="public-chat"
                >ALLE CHATS</a
                >
            </li>
            <li className="nav-item">
                <a
                    className={selectedRoom === 3 ? navActive: navInactive}
                    onClick={() => {setSelectedRoom(3)}}
                    id="group-chat-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="group-chat"
                >GRUPPENCHAT</a
                >
            </li>
        </ul>

        <div className="tab-content" id="myTabContent">
            <div
                className={selectedRoom === 1 ? contentActive: contentInactive}
                id="timeline"
                role="tabpanel"
                aria-labelledby="timeline"
            >
                <Timeline />
            </div>
            <div
                className={selectedRoom === 3 ? contentActive: contentInactive}
                id="group-chat"
                role="tabpanel"
                aria-labelledby="group-chat"
            >
               <GroupChat userProfile={userProfile} avatar={avatar}/>
               {/* <EmojiWidget />*/}
            </div>
            <div
                className={selectedRoom === 2 ? contentActive: contentInactive}
                id="timeline"
                role="tabpanel"
                aria-labelledby="timeline"
            >
              <PublicChat avatar={avatar}/>
            </div>
        </div>

        {changeProfile &&   <div className="modal fade show" id="my-profile" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-sm" role="document">
                <div className="modal-content">
                    <div className="modal-header">My Profile</div>
                    <div className="modal-body">
                        <div className="form">
                            <label className="profile-label" htmlFor="profileNickname">Nickname</label>
                            <input id="profileNickname" className="custom-input" value={nikname}
                                   onChange={(e) => setNikname(e.target.value)}/>

                            <label className="profile-label" htmlFor="profileAvatar">Avatar</label>
                            <div id="profileAvatar">
                                <div
                                    className={avatar === blueRobot ? "avatar-wrap activate": "avatar-wrap"}
                                     onClick={() => {
                                    selectAvatar(blueRobot)
                                }
                                }>
                                    <img id="avatarImage1" src={blueRobot}/>
                                </div>
                                <div
                                     className={avatar === redRobot ? "avatar-wrap activate": "avatar-wrap"}
                                onClick={() => {
                                selectAvatar(redRobot)}
                                }
                                >
                                    <img id="avatarImage2" src={redRobot}/>
                                </div>
                                <div
                                    className={avatar === blackRobot ? "avatar-wrap activate": "avatar-wrap"}
                                     onClick={() => {
                                selectAvatar(blackRobot)}
                                }>
                                    <img id="avatarImage3" src={blackRobot}/>
                                </div>
                                <div
                                    className={avatar === yellowRobot ? "avatar-wrap activate": "avatar-wrap"}
                                     onClick={() => {
                                selectAvatar(yellowRobot)}
                                }>
                                    <img id="avatarImage4" src={yellowRobot} />
                                </div>
                            </div>
                        </div>

                        <span
                            id="profile-res"
                            className="text-center request-result-message"
                        ></span>
                    </div>
                    <div className="modal-footer">
                        <button
                            id="updateNickname"
                            data-dismiss="modal"
                            onClick={() => updateProfile()}
                            className="btn btn-primary btn-block"
                        >
                            Update
                        </button>
                        <button
                            type="button"
                            data-dismiss="modal"
                            onClick={() => {
                                toggleChangeProfile(false)
                            }}
                            className="btn btn-block"
                            style={{ color: '#fff'}}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div> }

    </div>)

}

export default ChatTabs;